import { render, staticRenderFns } from "./ReadingAndSpeakingForm.vue?vue&type=template&id=5a91d22b&"
import script from "./ReadingAndSpeakingForm.vue?vue&type=script&lang=js&"
export * from "./ReadingAndSpeakingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports